import * as React from 'react';
import FormSetup from '../../../../../../components/Forms/FormSetup';
import { MasterConfigs } from '../../../../../../interfaces/entity';
import { Tag } from 'antd';
import { constants } from '../../../../../../constants/common';

const NextRoundModal = ({ isVisible, onClose, selected, level }) => {
    const [visible, setVisible] = React.useState(isVisible);
    const [form, setForm] = React.useState(null);

    React.useEffect(() => {
        setVisible(isVisible);
        if (!isVisible && form) {
            form.resetFields();
        }
    }, [isVisible])

    const commonRounds = [
        { name: "Test", value: constants.PROFILE_STATUS.TEST },
        { name: "Screening", value: constants.PROFILE_STATUS.SCREENING },
        { name: "Level 1", value: constants.PROFILE_STATUS.LEVEL_1 },
        { name: "Level 2", value: constants.PROFILE_STATUS.LEVEL_2 },
        { name: "Level 3", value: constants.PROFILE_STATUS.LEVEL_3 },
        { name: "Level 4", value: constants.PROFILE_STATUS.LEVEL_4 },
        { name: "Manager Round", value: constants.PROFILE_STATUS.MANAGER_ROUND },
        { name: "HR Round", value: constants.PROFILE_STATUS.HR_ROUND },
        { name: "Salary Discussion", value: constants.PROFILE_STATUS.SALARY_DISCUSSION },
    ];

    const preOnBoarding = [
        { name: "Genrate Offer", value: constants.PROFILE_STATUS.OFFER_GENRATE },
        { name: "Approval", value: constants.PROFILE_STATUS.APPROVAL },
        { name: "Release Offer Letter", value: constants.PROFILE_STATUS.RELEASE_OFFER_LETTER },
        { name: "Acceptance", value: constants.PROFILE_STATUS.ACCEPTANCE },
        { name: "Hired", value: constants.PROFILE_STATUS.HIRED },
        { name: "Joining On Hold", value: constants.PROFILE_STATUS.JOINING_ON_HOLD },
    ];

    // Check if all selected candidates have offer CTC and joining date
    const checkPreOnboardingEligibility = () => {
        if (!selected || selected.length === 0) return false;

        return selected.every(candidate => {
            const hasOfferCTC = candidate.offeredCTC && candidate.offeredCTC > 0;
            const hasJoiningDate = candidate.joiningDate && new Date(candidate.joiningDate).getTime() > 0;
            return hasOfferCTC && hasJoiningDate;
        });
    };

    const isPreOnboardingEligible = checkPreOnboardingEligibility();

    const salaryDiscussion = [
        {
            name: "Pre onboarding",
            value: constants.PROFILE_STATUS.PREE_OWNBORDING,
            disabled: !isPreOnboardingEligible
        }
    ];

    const getNextRoundOptions = (level) => {
        if (level === constants.PROFILE_STATUS.SALARY_DISCUSSION) {
            return [...salaryDiscussion, ...commonRounds];
        }

        if (level === constants.PROFILE_STATUS.PREE_OWNBORDING) {
            return [{ name: "Genrate Offer", value: constants.PROFILE_STATUS.OFFER_GENRATE }];
        }

        const preOnboardingLevels = [
            constants.PROFILE_STATUS.OFFER_GENRATE,
            constants.PROFILE_STATUS.APPROVAL,
            constants.PROFILE_STATUS.RELEASE_OFFER_LETTER,
            constants.PROFILE_STATUS.ACCEPTANCE,
            constants.PROFILE_STATUS.HIRED,
            constants.PROFILE_STATUS.JOINING_ON_HOLD
        ];

        if (preOnboardingLevels.includes(level)) {
            return [...preOnBoarding];
        }

        return [...commonRounds];
    };


    const config: MasterConfigs = {
        apiParams: { ids: selected?.map(ele => ele._id) },
        api: () => '/shortlistedCandidates/level/move/next',
        modalTitle: (text) => `${text} Next Round`,
        setForm: setForm,
        getFormColumns: (): any[] => {
            return [
                {
                    type: 'content',
                    span: 24,
                    items: <div>
                        {selected?.map(ele => <Tag color='blue' key={ele._id}>{constants.GET_FULL_NAME(ele)}</Tag>)}
                        {!isPreOnboardingEligible && (
                            <div style={{ marginTop: 8, color: '#ff4d4f', fontSize: '12px' }}>
                                Note: "Pre onboarding" option is disabled. Please ensure all selected candidates have Offer CTC and Joining Date added before moving to pre-onboarding.
                            </div>
                        )}
                    </div>
                },
                {
                    label: 'Next Round',
                    name: 'nextRound',
                    type: 'radio',
                    children: getNextRoundOptions(level),
                    rules: [{
                        required: true,
                        message: "Field is required"
                    }]
                }
            ];
        }
    }

    return <FormSetup config={config} open={visible} onClose={onClose} isModal={true} />
};

export default NextRoundModal;